import apiClient from './apiClient';

export const referralService = {
  getMySummary() {
    return apiClient.get('/referrals/me').then((res) => res.data);
  },
};
